"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.H6 = exports.H5 = exports.H4 = exports.H3 = exports.H2 = exports.H1 = void 0;
var react_1 = __importDefault(require("react"));
function getClassName(className, appendClassname) {
    if (appendClassname) {
        className += " " + appendClassname;
    }
    return className;
}
function H1(_a) {
    var children = _a.children, className = _a.className;
    return react_1.default.createElement("h1", { className: getClassName('storybook-pages-texts-headings-h1', className) }, children);
}
exports.H1 = H1;
function H2(_a) {
    var children = _a.children, className = _a.className;
    return react_1.default.createElement("h2", { className: getClassName('storybook-pages-texts-headings-h2', className) }, children);
}
exports.H2 = H2;
function H3(_a) {
    var children = _a.children, className = _a.className;
    return react_1.default.createElement("h3", { className: getClassName('storybook-pages-texts-headings-h3', className) }, children);
}
exports.H3 = H3;
function H4(_a) {
    var children = _a.children, className = _a.className;
    return react_1.default.createElement("h4", { className: getClassName('storybook-pages-texts-headings-h4', className) }, children);
}
exports.H4 = H4;
function H5(_a) {
    var children = _a.children, className = _a.className;
    return react_1.default.createElement("h5", { className: getClassName('storybook-pages-texts-headings-h5', className) }, children);
}
exports.H5 = H5;
function H6(_a) {
    var children = _a.children, className = _a.className;
    return react_1.default.createElement("h6", { className: getClassName('storybook-pages-texts-headings-h6', className) }, children);
}
exports.H6 = H6;
